export function getTopDialogZindex() {
    return (
        window['priModalDlg'] &&
        window['priModalDlg'].getTopDialogZindex &&
        window['priModalDlg'].getTopDialogZindex()
    );
}

export function updateTopDialogZindex(isIncrease: boolean) {
    const increase = isIncrease ? 1 : -1;
    const zIndex = (parseFloat(getTopDialogZindex()) + increase).toString();

    return (
        window['priModalDlg'] &&
        window['priModalDlg'].setTopDialogZindex &&
        window['priModalDlg'].setTopDialogZindex(zIndex)
    );
}

export function setIsCloseKeysBlocked(isBlocked: boolean) {
    return (
        window['priModalDlg'] &&
        window['priModalDlg'].setIsCloseKeysBlocked &&
        window['priModalDlg'].setIsCloseKeysBlocked(isBlocked)
    );
}
